import React from 'react';
import s from './index.module.scss';
import giftImage from './img/gift.png';
import locales from '../../../content.json';

export const DiscountBlock = () => {

	return (
		<div className={s.discountBlock}>
			<p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_31}} />
			<img src={giftImage} alt='gift' />
		</div>
	);
};